import { Http, Response } from '@angular/http';
import { JWTUtil } from '../_utils/jwt.util';
import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { APPCONFIG } from '../config';
import { User } from '../_models/user';
import { MarinaCompany } from '../_models/marina-company.model';
import { TipoFormaPagamento } from '../_models/finances/tipo-forma-pagamento';
import { EasyMarineHttpFinances } from '../_utils/easy-marine-http-finances';

@Injectable()
export class FinancesService {

    constructor(
        private http: EasyMarineHttpFinances
    ) { }

    findTipoFormasPagamento(marinaCompany?: MarinaCompany): Observable<TipoFormaPagamento[]> {
        return this.http.get(APPCONFIG.finApiIntegracao + 'tipo/formapagamento/contas', {}, marinaCompany).map((response: any) => response);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_services/finances.service.ts